import Typography from "@mui/material/Typography";
import { type FC } from "react";

import { RichTooltip } from "~/components/UI/RichTooltip";
import { useFormatDateCounter } from "~/hooks/useFormatDateCounter";
import { MarketStatus, type MarketStatusValue } from "~/types/event";

export interface EndDateCellProps {
  endDate: string | null;
  marketStatus: MarketStatusValue;
}

export const EndDateCell: FC<EndDateCellProps> = ({
  endDate,
  marketStatus,
}) => {
  const { formattedTime, isError, isPast, tooltipTitle } =
    useFormatDateCounter(endDate);

  if (!endDate) {
    return <Typography variant="caption">N/A</Typography>;
  }

  const isSettled = isPast && marketStatus === MarketStatus.RESOLVED;

  return (
    <RichTooltip title={tooltipTitle}>
      <Typography variant="caption" color={isError ? "error" : "inherit"}>
        {isSettled ? "Settled" : formattedTime}
      </Typography>
    </RichTooltip>
  );
};
